// @flow

import React from 'react';
import styled from 'styled-components';

const AriaHidden = styled.span`
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
  pointer-events: none;
`;

type Props = {
  hiddenText: string,
};

const VisuallyHidden = ({ hiddenText }: Props) => <AriaHidden>&nbsp; {hiddenText}</AriaHidden>;

export default VisuallyHidden;
